<template>
  <div class="content">
    <progress-bar :percent="50" />

    <div v-if="$store.getters.isRWB" class="info-text">
      What is connected to R{{ currentIndex + 1 }}, W{{ currentIndex + 1 }}, B{{
        currentIndex + 1
      }}?
    </div>
    <div v-else-if="$store.getters.is2P" class="info-text">
      What is connected to L1-{{ currentIndex * 2 + 1 }}, L2-{{
        currentIndex * 2 + 2
      }}?
    </div>
    <div v-else class="info-text">
      What is connected to L1-{{ currentIndex + 1 }}, L2-{{ currentIndex + 1 }},
      L3-{{ currentIndex + 1 }}?
    </div>

    <BlackISVG class="info-icon" @click="noteVisible = true" />

    <a-form-model ref="form" :model="form" :rules="rules" class="input-box">
      <a-form-model-item prop="connections">
        <a-input
          :id="addressInputId"
          v-model="form.connections"
          size="large"
          placeholder="Type in unit name"
          :data-tn="`unit-input-${currentIndex + 1}`"
          @input="onInputChange"
        />
        <IdealPostcodesAutoComplete
          v-if="useIdealPostcodes"
          :value="form.connections"
          :checked="true"
          :disabled="false"
          :input-id="addressInputId"
          @input="(value) => (form.connections = value)"
          @entry-meta-change="onEntryMetaChange"
        />
      </a-form-model-item>
    </a-form-model>

    <a-row type="flex" align="middle" class="back-n-next">
      <a-col :span="12">
        <back-button :style="{ marginTop: 0 }" />
      </a-col>
      <a-col :span="12">
        <yellow-button
          data-tn="phase-type-single-next"
          :loading="loading"
          @click="nextClicked"
        >
          NEXT
        </yellow-button>
      </a-col>
    </a-row>

    <yellow-modal v-model="noteVisible" icon padding="62px 26px 21px 26px">
      <div :style="{ fontSize: '21px', marginBottom: '1em' }">
        Enter the connected unit details eg:<br />
        - Apt 1<br />
        - Unit B<br />
        - Common light & power
      </div>
    </yellow-modal>
  </div>
</template>

<script>
import BlackISVG from "../assets/svg/black-i-filled.svg";
import IdealPostcodesAutoComplete from "../components/IdealPostcodesAutoComplete";
import { COUNTRY_CODE, PHASE } from "../util/constants";
export default {
  components: { BlackISVG, IdealPostcodesAutoComplete },
  data() {
    return {
      noteVisible: false,
      loading: false,
      form: {
        connections: "",
      },
      connectionMeta: {
        externalPropertyId: null,
        externalPropertyIdSource: null,
      },
      rules: {
        connections: [
          {
            required: true,
            message: "Please input connection",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    currentIndex() {
      return Number(this.$route.params.index);
    },
    useIdealPostcodes() {
      const projectCountry = this.$store?.state?.project?.address?.country;
      return projectCountry === COUNTRY_CODE["United Kingdom"];
    },
    addressInputId() {
      return `lookup-address-single-${this.currentIndex + 1}`;
    },
  },
  created() {
    const currentConnection =
      this.$store.state.project.connections[this.currentIndex];
    const currentConnectionMeta =
      this.$store.state.project.connectionEntryMeta[this.currentIndex];

    this.form.connections = currentConnection?.L1 || "";
    this.connectionMeta = {
      externalPropertyId:
        currentConnectionMeta?.[PHASE.L1]?.externalPropertyId || null,
      externalPropertyIdSource:
        currentConnectionMeta?.[PHASE.L1]?.externalPropertyIdSource || null,
    };
  },
  methods: {
    onInputChange() {
      if (!this.useIdealPostcodes) {
        this.connectionMeta = {
          externalPropertyId: null,
          externalPropertyIdSource: null,
        };
      }
    },
    onEntryMetaChange(meta) {
      this.connectionMeta = {
        externalPropertyId: meta?.externalPropertyId || null,
        externalPropertyIdSource: meta?.externalPropertyIdSource || null,
      };
    },
    nextClicked() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit("setConnection", {
            index: this.currentIndex,
            connection: {
              L1: this.form.connections,
              L2: this.form.connections,
              L3: this.form.connections,
            },
          });

          [PHASE.L1, PHASE.L2, PHASE.L3].forEach((phase) => {
            this.$store.commit("setConnectionEntryMeta", {
              index: this.currentIndex,
              phase,
              meta: this.connectionMeta,
            });
          });

          this.navigate();
          this.reset();
        } else {
          return false;
        }
      });
    },
    reset() {
      this.form.connections = "";
      this.connectionMeta = {
        externalPropertyId: null,
        externalPropertyIdSource: null,
      };
    },
    async navigate() {
      this.loading = true;
      await this.$store.dispatch("doUploadConnection");
      this.loading = false;
      if (this.currentIndex === 4) {
        this.$router.push(`/commission/15`);
      } else {
        this.$router.push(`/commission/12/${this.currentIndex + 1}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  .info-text {
    margin-top: 29px;
    margin-bottom: 10px;
  }

  .info-icon {
    margin-bottom: 20px;
  }
  .white-button {
    margin-bottom: 13px;
  }
  .input-box {
    margin-bottom: 37px;
  }
}
</style>
